import { Navigate, useLocation } from "react-router-dom";

export default function FacilityPeopleIndexPage() {
  const location = useLocation();
  return <Navigate to={`${location.pathname}/employees`} replace />;
}
